/* eslint-disable */
import Api from 'lib/api';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';

const LinkProduct = props => {
  window.location.href = props.data.url;

  return true;
};

LinkProduct.displayname = 'LinkProduct';

export default LinkProduct;
